var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-modal',{attrs:{"modal-id":_vm.$options.itemRemoveModalId,"title":_vm.modalTitle,"no-fade":"","action-primary":_vm.$options.modal.actionPrimary,"action-cancel":_vm.$options.modal.actionCancel},on:{"primary":function($event){return _vm.removeItem({
      parentItem: _vm.removeItemModalProps.parentItem,
      item: _vm.removeItemModalProps.item,
    })}}},[_c('p',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.modalBody),expression:"modalBody"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }